// extracted by mini-css-extract-plugin
module.exports = {"cards":"GenreSlider_cards__nCiVn"};